window.addEventListener('DOMContentLoaded', function () {

    /**
     * Custom jQuery functions
     */
    jQuery.fn.extend({
        numVal: function (value = undefined) {
            if (value === undefined) {
                return $(this).val() === undefined ? 0 : Number($(this).val().replace(/,/g, ''));
            }
            $(this).val(Number(value).toLocaleString());
            return this;
        },
        floatVal: function (fixed = 4, abs = true) {
            let value = $(this).numVal();
            value = abs ? Math.abs(value) : value;
            return isNaN(value) ? 0 : parseFloat(value.toFixed(fixed));
        },
        formatFloatVal: function (fixed = 4, abs = true) {
            $(this).val(
                $(this).floatVal(fixed, abs).toLocaleString(undefined, {'maximumFractionDigits': fixed})
            );
            return this;
        },
        formatFloatValNeg: function (fixed = 4) {
            $(this).formatFloatVal(fixed, false);
            return this;
        },
        setSelectedVal: function (value) {
            $(this).find('option').removeAttr('selected');
            $(this).find('option[value="' + value + '"]').attr('selected', 'selected');
        },
        clearProduct: function () {
            clearProduct(this);
            return this;
        },
        cleanGroup: function () {
            cleanGroup(this);
            return this;
        }
    });

});

/**
 * 編集フォームの変更イベントをトリガーする
 */
window.triggerEditFormChange = function (form = '#editForm') {
    $(form).trigger('change');
}

/**
 * フォーマットされた浮動小数点値を取得する
 */
window.getFormattedFloatVal = function (value, fixed = 4) {
    let abs = Math.abs(value);
    let float = isNaN(abs) ? 0 : parseFloat(abs.toFixed(fixed));
    return float.toLocaleString(undefined, {'maximumFractionDigits': fixed});
}
